export default __webpack_public_path__ + "static/globe-62a7bdee74a1317e7c5187c39f844a96.jpeg";